import React from 'react';
import ReactDOM from 'react-dom';

import "./lib/axios";

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
